<app-header [transparent]="transparent"></app-header>
<div class="our_partner">
  <ng-container *ngFor="let heading of head">
    <div class="text-center  inline_padding1 our_partner_top" *ngIf="heading.page === currentPage">
      <div>
        <span class="text_style_5">Our Partners</span>
      </div>
      <div class="p-top-16">
        <span [innerHTML]="heading.page_sub_heading"></span>
      </div>
    </div>
  </ng-container>
  <div class="our_partner_content bottom_padding1 inline_padding1 bg_2">
    <div class="our_partner_content_flex">
      <div class="our_partner_content_flex_list bg_1">
        <ng-container *ngFor="let partner of partners; let i = index">
          <div *ngIf="i !== selectedItem" (click)="selectItem(i)" class="our_partner_content_flex_list_item"
            [ngClass]="i + 1 === partners.length ? '' : 'border_right_black'">
            <img [src]="getPartnerLogo(partner)" alt="logo"
              class="our_partner_content_flex_list_item_img width-50-per" />
          </div>
          <div *ngIf="i === selectedItem" class="our_partner_content_flex_list_selected"
            [ngClass]="i + 1 === partners.length ? '' : 'border_right_black'">
            <div class="our_partner_content_flex_list_selected_item">
              <img [src]="getPartnerLogo(partner)" alt="logo" class="width-80-per" />
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="top_padding2">
      <span class="text_black_7" *ngIf="partners[selectedItem]?.name" [innerHTML]="partners[selectedItem]?.name"></span>
    </div>
    <div class="p-top-18">
      <span class="text_blue_7" *ngIf="partners[selectedItem]?.sub_title"
        [innerHTML]="partners[selectedItem]?.sub_title"></span>
    </div>

    <div class="p-top-16">
      <div class="text_style_9 text-wrap ql-editor description-wrapper" *ngIf="partners[selectedItem]?.description"
        [innerHTML]="partners[selectedItem]?.description"></div>
    </div>

    <div *ngIf="partners && partners.length > 0" class="p-top-12" style="display: flex; justify-content: flex-start;">
      <button type="button" class="rounded-pill text_white_1 button_blue_7"
        (click)="openLink(getPartnerWebLink(partners[selectedItem]))"
        style="width: 150px; padding: 12px 24px; display: flex; justify-content: space-between; align-items: center; border: 0;">
        <span class="button_blue_1_text" style="font-size: 16px;">Weblink</span>
        <img class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png"
          style="height: 14px; max-width: none; object-fit: contain; margin-left: 10px;" />
      </button>
    </div>
    <div class="share-buttons" style="margin-top:15px;">
      <button (click)="copyLink()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fas fa-link" style="color: #000;"></i> <!-- Copy Link -->
      </button>
      <button (click)="shareViaEmail()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fas fa-envelope" style="color: #EA4335;"></i> <!-- Email -->
      </button>
      <button (click)="shareViaSMS()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fas fa-sms" style="color: #25D366;"></i> <!-- SMS -->
      </button>
      <button (click)="shareViaWhatsApp()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-whatsapp" style="color: #25D366;"></i> <!-- WhatsApp -->
      </button>
      <button (click)="shareViaMessenger()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-facebook-messenger" style="color: #0084FF;"></i> <!-- Messenger -->
      </button>
      <button (click)="shareViaViber()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-viber" style="color: #59267C;"></i> <!-- Viber -->
      </button>
      <button (click)="shareViaFacebook()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-facebook" style="color: #4267B2;"></i> <!-- Facebook -->
      </button>
      <button (click)="shareViaTwitter()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-twitter" style="color: #1DA1F2;"></i> <!-- Twitter -->
      </button>
      <button (click)="shareViaLinkedIn()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-linkedin" style="color: #0077B5;"></i> <!-- LinkedIn -->
      </button>
      <button (click)="shareViaPinterest()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-pinterest" style="color: #E60023;"></i> <!-- Pinterest -->
      </button>
      <button (click)="shareViaReddit()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-reddit" style="color: #FF4500;"></i> <!-- Reddit -->
      </button>
      <button (click)="shareViaTumblr()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-tumblr" style="color: #35465C;"></i> <!-- Tumblr -->
      </button>
      <button (click)="shareViaTelegram()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-telegram" style="color: #0088CC;"></i> <!-- Telegram -->
      </button>
      <button (click)="shareViaVK()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-vk" style="color: #4B7BE5;"></i> <!-- VK -->
      </button>
      <button (click)="shareViaMix()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-mix" style="color: #00A3E0;"></i> <!-- Mix -->
      </button>
      <button (click)="shareViaXing()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-xing" style="color: #006567;"></i> <!-- Xing -->
      </button>
      <button (click)="shareViaLine()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-line" style="color: #00B900;"></i> <!-- Line -->
      </button>

    </div>
  </div>


  <div class="our_partner_phn">
    <div class="our_partner_phn_body">
      <ng-container *ngFor="let partner of partners; let i = index">
        <!-- Conditional class for bottom_border_trans_5 -->
        <div [ngClass]="{'bottom_border_trans_5': i < partners.length - 1}"
          class="our_partner_phn_body_container p-y-33 p-x-10">
          <div class="our_partner_phn_body_container_img">
            <img [src]="getPartnerLogo(partner)" alt="logo" class="our_partner_phn_body_container_img_inner" />
          </div>
          <div>
            <div class="">
              <span class="text_black_7" [innerHTML]="partner.name"></span>
            </div>
            <div class="p-top-18">
              <span class="text_blue_7" [innerHTML]="partner.sub_title"></span>
            </div>
            <div class="p-top-16">
              <div class="text_style_9 text-wrap ql-editor description-wrapper" [innerHTML]="partner.description"></div>
            </div>
            <div class="p-top-12" style="display: flex; justify-content: flex-start;">
              <button type="button" class="rounded-pill text_white_1 button_blue_7"
                (click)="openLink(getPartnerWebLink(partner))"
                style="width: 150px; padding: 12px 24px; display: flex; justify-content: space-between; align-items: center; border: 0;">
                <span class="button_blue_1_text" style="font-size: 16px;">Weblink</span>
                <img class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png"
                  style="height: 14px; max-width: none; object-fit: contain; margin-left: 10px;" />
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>


</div>
<app-footer />